import * as z from "zod";

export const disconnectAcumaticaIntegration = {
  name: "disconnectAcumaticaIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
